
import Vue from 'vue'
import ProjectDetails from '@/components/project/ProjectDetails.vue'
import { Project } from '@/model/Project'
import ItemsHorizontalList from '@/components/ItemsHorizontalList.vue'
import {ContestApplication} from "@/model/ContestApplication";

export default Vue.extend({
  name: 'Project',

  props: {
    slug: {
      type: String,
    },
  },

  computed: {
    relatedProjectsLink: function (): string {
      if (!this.project) {
        return ''
      }

      const tags = []

      for (let i = 0; i < this.project.tags.length; i++) {
        tags.push(this.project.tags[i].id)
      }

      return '/projects/all/' + tags.join(',') + '/any-contest/newest'
    },
  },

  components: {
    ProjectDetails,
    ItemsHorizontalList,
  },

  mounted() {
    (this as any).fetchProject()
  },

  data: () => ({
    project: null as Project | null,
    relatedProjects: [] as Project[],
    applications: [] as ContestApplication[],
    loading: true
  }),

  methods: {
    fetchProject: function () {
      (this as any).loading = true;
      this.$api.get('/projects/' + (this as any).slug)
          .then((response) => {
            (this as any).project = response.data;
            return this.$api.get('/contests/applications?projectId=' + this.project?.id as string + '&statuses=accepted,new');
          })
          .then((response) => {
            (this as any).applications = response.data['items'];
          })
          .then(() => {
            this.$api
                .get('/projects/' + (this as any).project.id + '/related', {

                })
                .then((response: any) => {
                  (this as any).relatedProjects = response.data['items']
                })
          })
          .catch(() => this.$router.push('/404'))
          .finally(() => {
            (this as any).loading = false;
          });
    },

    updateUserScore: function (userScore: number) {
      if (!this.project) {
        return
      }

      this.project.userScore = userScore
    },

    updateUserAverageScore: function (userAverageScore: number) {
      if (!this.project) {
        return
      }

      this.project.score = userAverageScore
    },
  },

  watch: {
    '$route.params': function () {
      (this as any).fetchProject()
    },
  },
})
